const MONTHS = {
  nl: [
    "Januari",
    "Februari",
    "Maart",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
};

export function formatDate(date, locale) {
  const { day, month, year } = getDayMonthYearForDate(date, locale);
  if (!day || !month || !year) return null;
  return `${day} ${month} ${year}`;
}

export function formatDatePreview(date, locale) {
  const { day, month, year } = getDayMonthYearForDate(date, locale);
  if (!day || !month || !year) return null;
  return [day, month.substr(0, 3)];
}

export function getDayMonthYearForDate(date, locale) {
  const d = new Date(date);
  if (isNaN(d.getTime())) return {};

  const day = d.getDate();
  const month = MONTHS[locale][d.getMonth()];
  const year = d.getFullYear();

  return { day, month, year };
}

export const getTodayISOString = () => {
  const yesterday = new Date();
  yesterday.setDate(new Date().getDate());
  return yesterday.toISOString();
};

export const getYesterdayISOString = () => {
  const yesterday = new Date();
  yesterday.setDate(new Date().getDate() - 1);
  return yesterday.toISOString();
};
